var GtxFaviconTitleManager = (function () {

    const {events: menuCountersManagerEvents} = require('./gtx-menu-counters-worker-manager')

    let initialPageTitle;
    
    const setNotificationMetaTitle = (value) => {
        if (!initialPageTitle) {
            initialPageTitle = document.title;
        }

        if (value) {
            const unreadMessages = value > 99 ? "99+" : value;
            document.title = `(${unreadMessages}) ${initialPageTitle}`;
        } else {
            document.title = initialPageTitle;
        }
    };

    /**
     * Favicons, not being part of the DOM, are not updated when the page title is changed.
     * @param {*} value
     */
    const setNotificationFavicons = (value) => {
        const favicons = document.querySelectorAll('link[rel="icon"]');
        favicons.forEach((favicon) => {
            let href = favicon.href;
            const extension = href.match(/\.[^.]*$/);
            const notificationPathAlreadyActive = href.includes("_notification");

            // Do nothing if there are already a value and notification icon is showed
            if (value && notificationPathAlreadyActive) {
                return;
            }

            // If has at least 1 new item set notification icon
            if (value && !notificationPathAlreadyActive) {
                href = href.replace(extension, `_notification${extension}`);
            } else {
                href = href.replace(`_notification${extension}`, extension);
            }

            return favicon.setAttribute("href", href);
        });
    };

    const updateTitleAndFavIcon = (ev) => {
        const data = ev.detail;
        const result = (data.newMatches ?? 0) + (data.newAgencyActiveSearches ?? 0) + (data.unreadThreads ?? 0)
        setNotificationFavicons(result);
        setNotificationMetaTitle(result);
    }


    const initialize = () => {
        console.log('GtxFaviconTitleManager:: init')
        window.addEventListener(menuCountersManagerEvents.UPDATE_COUNTERS, updateTitleAndFavIcon)
    };

    return {
        initialize
    }
})()

module.exports = GtxFaviconTitleManager;
